<template>
	<section class="social-login__form multifactor-verification">
		<c-multifactor-input
			ref="mfaInput"
			:is-validated="status === 'success'"
			:is-loading="status === 'validating'"
			autofocus
			input-classes="mt-3"
			label="Enter your two-factor authenticator app code to continue."
			@complete="onCodeEntered"
		/>
		<div class="sz-2">
			<c-checkbox
				v-if="showRememberDevice"
				id="remember-this-device"
				v-model="rememberThisDevice"
				class="mb-4 sz-2 flex flex--center"
				label="Remember This Device"
			/>
			<p class="text-center m-0">
				Can't access your authenticator?
			</p>
			<button class="button--no-style text-center underline w-100" @click="sendMfaBackupEmail">
				Send a two-factor code to {{ mfaResult.ObfuscatedBackupEmail }}
			</button>
		</div>
	</section>
</template>

<script lang="ts">
	import CMultifactorInput from 'src/components/form-controls/MultifactorInput.vue';
	import CCheckbox from '@cognitoforms/shared-components/src/components/form-controls/Checkbox.vue';
	import { defineComponent, ref } from 'vue';
	import type { MultifactorResult } from '@cognitoforms/types/server-types/services/infrastructure/authentication/multifactor-result';
	import type { PropType } from 'vue';
	import type { ButtonStatus } from '@cognitoforms/shared-components/src/components/interaction/StatusButton.vue';

	export default defineComponent({
		components: {
			CMultifactorInput,
			CCheckbox
		},
		props: {
			mfaResult: {
				type: Object as PropType<MultifactorResult>,
				default: () => {}
			},
			status: {
				type: String as PropType<ButtonStatus>,
				default: 'default'
			},
			showRememberDevice: {
				type: Boolean,
				default: false
			}
		},
		emits: ['validate-multifactor', 'send-mfa-backup-code'],
		setup(props, { emit }) {
			const mfaInput = ref<InstanceType<typeof CMultifactorInput>>(null);
			const rememberThisDevice = ref<boolean>(false);
			const onCodeEntered = (code: string) => {
				emit('validate-multifactor', code, rememberThisDevice.value);
			};

			const sendMfaBackupEmail = () => {
				emit('send-mfa-backup-code');
			};

			return {
				mfaInput,
				rememberThisDevice,
				onCodeEntered,
				sendMfaBackupEmail
			};
		}
	});
</script>

<style lang="scss">
:root:root:root .multifactor-verification {
	gap: 0;
}
</style>